<template>
    <div class="container">
        <div v-if="deleteable">
            <h1>Delete scale?</h1>
            <button @click="confirm()" style="background-color: #dc3545; margin-right: 2rem;">
                <h2>Yes</h2>
            </button>
            <button @click="this.$router.push('/manage')">
                <h2>No</h2>
            </button>
        </div>
        <div v-else>
            <h1>Scale is in use and cannot be deleted.</h1>
            <h2 style="text-align: left;">Surveys:</h2>
            <h2 v-for="(survey, i) in related" v-bind:key="i" style="text-align: left;">{{ survey }}</h2>
            <button @click="this.$router.push('/manage')">
                <h2>Back</h2>
            </button>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { baseurl } from "../api";
import accountStore from '../accountStore';
export default {
    methods: {
        confirm() {
            axios.post(baseurl + "deletescale", { id: this.$route.params.id, p: accountStore.passcode }).then((r) => {
                if (r.data.success) {
                    this.$router.push("/manage");
                    return;
                }
            });
        },
    },
    created() {
        if (!accountStore.verified) {
            this.$router.push("/admin");
        }
        axios.get(baseurl + "scaledeleteable", { params: { id: this.$route.params.id, p: accountStore.passcode } }).then((r) => {
            if (r.data.deleteable) {
                this.deleteable = true;
                return;
            }
            this.deleteable = false;
            this.related = r.data.related;
        });
    },
    data() {
        return {
            deleteable: false,
            related: [],
        };
    },
    name: "DeleteScale",
};
</script>

<style scoped>
.container {
    margin-bottom: 2rem;
}

input {
    border: 1px solid #555555;
    border-radius: 1rem;
    padding: 1rem 1rem;
    margin: 0 1rem;
    font-size: 1rem;
    font-weight: bold;
    height: 100%;
}

.errored {
    border: 1px solid #ff0000;
}

.errored:focus {
    outline-color: #ff0000;
}

button {
    background-color: #007bff;
    border: none;
    border-radius: 1rem;
    cursor: pointer;
}

button>h2 {
    color: #ffffff;
    margin: 0.8rem 1rem;
}

.inputrow {
    display: flex;
    align-items: center;
}

h5 {
    text-align: left;
    margin: 0.3rem 1.7rem;
    color: #c70000;
    visibility: hidden;
}

.shown {
    visibility: visible;
}
</style>
